import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { userService } from "../../_services";
import SignupHeader from "./signup_header";
import Signupleft from "../../images/signupleft.webp";
import signupcheck from "../../images/savecheck.png";

const Activate_Account = () => {
    const [activationStatus, setActivationStatus] = useState('');
    const [userRole, setUserRole] = useState('');
    const [activationMessage, setActivationMessage] = useState('');

    useEffect(() => {
        try {
            const params = window.location.search.replace('?uid=', '');
            const arr = params.split('/');
            let emailcode = '';
            
            for (let i = 0; i < arr.length - 1; i++) {
                if (emailcode === '') {
                    emailcode = arr[i];
                } else {
                    emailcode = emailcode + '/' + arr[i];
                }
            }
            
            activateUserAccount(emailcode, arr[arr.length - 1]);
        } catch (err) {
            console.error('Activation error:', err);
        }
    }, []);

    const activateUserAccount = async (EmailId, ObjectUid) => {
        try {
            const apidata = await userService.ActivateAccount(EmailId, ObjectUid);
            
            if (apidata.length > 0) {
                if (apidata[0].message === 'Your account is activated successfully.') {
                    setActivationStatus('1');
                    setUserRole(apidata[0].userType);
                    setActivationMessage(apidata[0].message);
                } else {
                    setActivationStatus(apidata[0].code);
                    setUserRole(apidata[0].userType);
                    setActivationMessage(apidata[0].message);
                }
                localStorage.setItem('UserRole', window.btoa(apidata[0].userType));
            } else {
                setActivationStatus('-1');
                setActivationMessage('Account error, Invalid request parameters...');
            }
        } catch (error) {
            setActivationStatus('-1');
            setActivationMessage('Account error, Invalid request parameters..');
        }
    };

    const getSignInLink = () => {
        return userRole === "consumer" ? "/consumerlogin" : "/login";
    };

    return (
        <div className="min-h-screen bg-secondary">
            <SignupHeader />
            
            <div className="w-full mx-auto">
                <div className="flex items-center justify-center min-h-[calc(100vh-80px)]">
                    <div className="w-full max-w-[1260px] mx-auto px-4 md:px-8">
                        <div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-16">
                            {/* Left side - Image */}
                            <div className="flex-1 flex items-center justify-center md:max-w-[689px]">
                                <img 
                                    src={Signupleft} 
                                    alt="Account Activation" 
                                    className="w-full h-auto object-contain"
                                />
                            </div>

                            {/* Right side - Activation Status */}
                            <div className="flex-1 flex items-center justify-center md:max-w-[490px]">
                                <div className="w-full space-y-6 text-center">
                                    {activationStatus === '' ? (
                                        // Loading State
                                        <>
                                            <div className="space-y-4">
                                                <p className="text-lg text-foreground">
                                                    Please wait while your request is processing
                                                    <span className="inline-flex ml-1">
                                                        <span className="animate-bounce delay-0">.</span>
                                                        <span className="animate-bounce delay-100">.</span>
                                                        <span className="animate-bounce delay-200">.</span>
                                                    </span>
                                                </p>
                                            </div>
                                        </>
                                    ) : activationStatus === '-1' ? (
                                        // Error or Already Activated State
                                        <>
                                            {!activationMessage.toLowerCase().includes('error') && (
                                                <div className="flex justify-center mb-6">
                                                    <img 
                                                        src={signupcheck} 
                                                        alt="Success" 
                                                        className="w-32 h-32 object-contain"
                                                    />
                                                </div>
                                            )}
                                            <div className="space-y-4">
                                                <p className="text-lg text-foreground">
                                                    {activationMessage}
                                                </p>
                                            </div>
                                            {!activationMessage.toLowerCase().includes('error') && (
                                                <div className="pt-4">
                                                    <Link to="/login">
                                                        <Button 
                                                            size="lg" 
                                                            className="bg-accent hover:bg-accent/90 text-white w-auto"
                                                        >
                                                            Sign In Now
                                                        </Button>
                                                    </Link>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        // Success State
                                        <>
                                            <div className="flex justify-center mb-6">
                                                <img 
                                                    src={signupcheck} 
                                                    alt="Success" 
                                                    className="w-32 h-32 object-contain"
                                                />
                                            </div>
                                            <div className="space-y-4">
                                                <p className="text-lg text-foreground">
                                                    Your account has been activated successfully
                                                </p>
                                            </div>
                                            <div className="pt-4">
                                                <Link to={getSignInLink()}>
                                                    <Button 
                                                        size="lg" 
                                                        className="bg-accent hover:bg-accent/90 text-white w-auto"
                                                    >
                                                        Sign In Now
                                                    </Button>
                                                </Link>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Activate_Account;
